export const SYSTEM_ROLES = [
  { key: 'admin', label: 'Admin' },
  { key: 'receptionist', label: 'Receptionist' },
  { key: 'pharmacist', label: 'Pharmacist' },
  { key: 'nurse', label: 'Nurse' },
  { key: 'labtech', label: 'Lab Tech' },
  { key: 'b2b', label: 'B2B Manager' },
];

export const ROLE_COLORS = {
  admin: 'bg-amber-100 text-amber-700',
  receptionist: 'bg-blue-100 text-blue-700',
  pharmacist: 'bg-green-100 text-green-700',
  nurse: 'bg-rose-100 text-rose-700',
  labtech: 'bg-cyan-100 text-cyan-700',
  b2b: 'bg-indigo-100 text-indigo-700',
};

export const CORE_MODULES = [
  { key: 'appointments', label: 'Appointments', description: 'Booking follow-up and status tracking', assignable: true },
  { key: 'accounts', label: 'Accounts', description: 'Cash, revenue, and shift balance updates', assignable: true },
  { key: 'wanted', label: 'Wanted List', description: 'Item requests and approvals', assignable: true },
  { key: 'daily_tasks', label: 'Daily Tasks', description: 'Task checklists and management assignments', assignable: true },
  { key: 'healthcard', label: 'Health Card', description: 'Card enquiries, conversions, and incentives', assignable: true },
  { key: 'attendance', label: 'Attendance', description: 'GPS check-in, leave, time correction, permission, and camp duty', assignable: true },
  { key: 'home_collection', label: 'Home Collection', description: 'Assign and complete home sample visits', assignable: true },
  { key: 'b2b', label: 'B2B Leads', description: 'Diagnostic partner outreach and conversion tracker', assignable: true },
];

const CORE_DEFAULTS = {
  admin: { dashboard: true, lab_tests: true, health_profiles: true, catalog_stats: true, staff_mgmt: true },
  receptionist: { appointments: true, accounts: true, wanted: true, daily_tasks: true, healthcard: true, attendance: true, home_collection: true },
  pharmacist: { appointments: true, wanted: true, daily_tasks: true, healthcard: true, attendance: true },
  nurse: { appointments: true, wanted: true, daily_tasks: true, healthcard: true, attendance: true },
  labtech: { wanted: true, daily_tasks: true, healthcard: true, attendance: true },
  b2b: { b2b: true },
};

export const getRoleLabel = (roleKey, roles = SYSTEM_ROLES) => roles.find((role) => role.key === roleKey)?.label || roleKey.replace(/_/g, ' ');

export const buildModulePermissions = (role, overrides = {}, modules = CORE_MODULES) => {
  const allKeys = ['dashboard', 'lab_tests', 'health_profiles', 'catalog_stats', 'staff_mgmt', ...modules.map((module) => module.key)];
  const uniqueKeys = [...new Set(allKeys)];
  const base = Object.fromEntries(uniqueKeys.map((key) => [key, false]));

  if (role === 'admin') {
    return Object.fromEntries(uniqueKeys.map((key) => [key, true]));
  }

  Object.entries(CORE_DEFAULTS[role] || {}).forEach(([key, value]) => {
    base[key] = value;
  });

  Object.entries(overrides || {}).forEach(([key, value]) => {
    base[key] = Boolean(value);
  });

  return base;
};

export const hasModuleAccess = (user, moduleKey) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (Object.prototype.hasOwnProperty.call(user.module_permissions || {}, moduleKey)) {
    return Boolean(user.module_permissions[moduleKey]);
  }
  return Boolean(CORE_DEFAULTS[user.role]?.[moduleKey]);
};

export const getEnabledModuleLabels = (user, modules = CORE_MODULES) => modules
  .filter((module) => hasModuleAccess(user, module.key))
  .map((module) => module.label);